import { NgClass } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputErrorComponent } from '@common/components/input/input-error/input-error.component';
import { InputLabelComponent } from '@common/components/input/input-label/input-label.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TextAreaComponent, TextBoxSuffixTemplateDirective } from '@progress/kendo-angular-inputs';
import { BaseInputComponent } from '../base-input/base-input.component';
import { formatCharacterCount } from '../input.helpers';
import { TextareaInputConfig } from '../input.type';

/**
 * Textarea input component.
 * @param maxLength - The maximum length of the text.
 * @param rows - The number of rows.
 */
@Component({
    selector: 'app-textarea-input',
    templateUrl: './textarea-input.component.html',
    providers: [{ provide: BaseInputComponent, useExisting: TextareaInputComponent }],
    imports: [
        InputLabelComponent,
        TextAreaComponent,
        TranslatePipe,
        FormsModule,
        NgClass,
        TextBoxSuffixTemplateDirective,
        InputErrorComponent
    ]
})
export class TextareaInputComponent extends BaseInputComponent<string> implements OnInit, OnChanges {
    @Input() maxLength: TextareaInputConfig['maxLength'] = 255;
    @Input() pattern: TextareaInputConfig['pattern'];
    @Input() rows: TextareaInputConfig['rows'] = 3;
    characterCount: string;

    ngOnInit(): void {
        this.clearValue(this.value());
        this.characterCount = formatCharacterCount(this.maxLength, this.value());
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.value) this.clearValue(changes.value.currentValue);
    }

    override onValueChange(value: string): void {
        super.onValueChange(value);
        this.characterCount = formatCharacterCount(this.maxLength, value);
    }

    onKeyPress(event: KeyboardEvent) {
        if (!this.pattern) return;
        if (!new RegExp(this.pattern).test(event.key)) event.preventDefault();
    }

    // This is to avoid displaying 'undefined' when the value passed in is undefined eg.: model.username, where username is undefined.
    clearValue(value: string) {
        if (!value) this.value.set(null);
    }
}
